import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="dash min-h-screen flex items-center justify-center font-mono2 text-sm">
        Loading dashboard…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
